import GridLayout from '@/directives/GridLayout';
export default {
  install(Vue) {
    Vue.directive('GridLayout', GridLayout);
  },
};
